export { default as InteriorMain } from './InteriorMain';
export * from './InteriorMain';
